<template functional>
  <btn
    class="m-b-10 m-r-5"
    type="secondary"
    size="sm"
    :title="`Click to add ${props.filter} filter`"
    v-on="listeners.click ? { click: listeners.click } : null"
  >
    <i class="fa fa-filter" />
    {{ props.filter }}
  </btn>
</template>

<script>
export default {
  name: 'PresetFilter',
  props: {
    filter: {
      type: String,
      default: ''
    },
  },
};
</script>